module.exports = __webpack_public_path__ + "img/ditan_xc5.4a28baeb.jpg";